import axiosInstance from "../../config/axiosInstance";
import { USER_API } from "../../Utils/constants/apis.urls";

// Register
export const registerUser = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.REGISTER, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Registration failed" };
  }
};

// Verify signup OTP
export const verifySignupOtp = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.VERIFY_SIGNUP_OTP, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Invalid OTP" };
  }
};

// Resend signup OTP
export const resendSignupOtp = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.RESEND_SIGNUP_OTP, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Failed to resend OTP" };
  }
};

// Verify password reset OTP
export const verifyOtp = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.VERIFY_RESET_OTP, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Invalid OTP" };
  }
};

// Login
export const loginUser = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.LOGIN, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Login failed" };
  }
};

// Google Login
export const googleLogin = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.GOOGLE_LOGIN, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Google login failed" };
  }
};

// Apple Login
export const appleLogin = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.APPLE_LOGIN, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Apple login failed" };
  }
};

// Forget Password
export const forgetPassword = async (payload) => {
  try {
    const response = await axiosInstance.post(
      USER_API.FORGET_PASSWORD,
      payload
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Something went wrong" };
  }
};

// Reset Password
export const resetPassword = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.RESET_PASSWORD, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Reset failed" };
  }
};

// Get User Info
export const getUserInfo = async () => {
  try {
    const response = await axiosInstance.get(USER_API.USER_INFO);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Failed to fetch user info" };
  }
};

// Update User Profile
export const updateUserProfile = async (payload) => {
  try {
    const response = await axiosInstance.patch(USER_API.USER_INFO, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Failed to update profile" };
  }
};

// Contact Us / Support Email
export const submitContactUs = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.CONTACT_US, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Failed to send message" };
  }
};

// Delete Account
export const deleteAccount = async (payload) => {
  try {
    const response = await axiosInstance.post(USER_API.DELETE_ACCOUNT, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || { error: "Failed to delete account" };
  }
};
